// extracted by mini-css-extract-plugin
export default {"login":"AuthLayout_login__Cvq9v","logo":"AuthLayout_logo__ODFCr"};